var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 18,
    viewBox: "0 0 54 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5014 17.4571H8.82775L5.32309 3.80806C5.15674 3.18021 4.80354 2.62515 4.28399 2.36354C2.9874 1.70611 1.55864 1.1829 0 0.919014V0.393525H7.52889C8.56798 0.393525 9.3473 1.1829 9.47719 2.09966L11.2956 11.9452L15.967 0.393525H20.5107L13.5014 17.4571ZM23.1056 17.4571H18.6917L22.3262 0.393525H26.7401L23.1056 17.4571ZM32.4537 5.12067C32.5836 4.20164 33.3629 3.67615 34.2721 3.67615C35.7008 3.54421 37.2572 3.80809 38.5561 4.46324L39.3354 0.789371C38.0365 0.263882 36.6078 0 35.3112 0C31.0272 0 27.9099 2.36356 27.9099 5.64389C27.9099 8.13939 30.118 9.4497 31.6766 10.2391C33.3629 11.0262 34.0123 11.5517 33.8824 12.3388C33.8824 13.5194 32.5836 14.0449 31.287 14.0449C29.7283 14.0449 28.1697 13.6513 26.7432 12.9939L25.9639 16.6701C27.5225 17.3252 29.2088 17.5891 30.7674 17.5891C35.571 17.7188 38.5561 15.3575 38.5561 11.8133C38.5561 7.35002 32.4537 7.08841 32.4537 5.12067ZM54.0002 17.4571L50.4955 0.393525H46.7311C45.9517 0.393525 45.1724 0.919014 44.9126 1.70611L38.4228 17.4571H42.9666L43.8735 14.9639H49.4564L49.976 17.4571H54.0002ZM47.3855 4.98874L48.6821 11.4197H45.0475L47.3855 4.98874Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank3);
export default __webpack_public_path__ + "static/media/bank3.3250d0505863ef41b683a797c2240e5a.svg";
export { ForwardRef as ReactComponent };